import { FINANCE_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
const axios = require('axios')

export default {
  getStepServiceProject (_id) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get(`stepServiceProject?serviceProject=${_id}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/StepServiceProject/api.js